import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function DemoDialog(props: { visible: boolean; onHide: () => void }): ReactElement {
  const { t } = useTranslation('demoApp')
  return (
    <Dialog
      header={t('InformativeBannerDemoAppTitle')}
      visible={props.visible}
      style={{ width: 'auto' }}
      onHide={props.onHide}
      footer={<Button label={t('CloseButtonLabel')} onClick={props.onHide} />}
    >
      <p className='m-0'>{t('InformativeBannerDemoApp')}</p>
    </Dialog>
  )
}
